import { Controller } from "stimulus"

export default class extends Controller {

    connect(){
        this.bTable = document.getElementById("MRB")
        this.cTable = document.getElementById("MRC")       
    }
    
    open(){
      let bChks =  this.bTable.querySelectorAll("tbody tr td input[type=checkbox]:checked")
      let cChks =  this.cTable.querySelectorAll("tbody tr td input[type=checkbox]:checked") 
      bChks.forEach((t) => {        
        t.checked = false
        let bsels = t.closest("tr").querySelectorAll("td select")
        bsels.forEach((x) => {
          x.disabled = true
          x.selectedIndex = ""
        })
      })
      cChks.forEach((t) => {        
        t.checked = false
        let csels = t.closest("tr").querySelectorAll("td select")
        csels.forEach((x) => {
          x.disabled = true
          x.selectedIndex = ""
        })
      })
      let havnon = document.getElementById("applied_for_level_not_section_a")
      if(havnon.checked)
      {
        havnon.click()
      }
    }

}